import styles from './styles.module.css';
import KitoSelect from '../../components/Inputs/Select';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import KitoBuddy from '../../components/Buddy';

const ageGroups = [
  {
    value: 0,
    labelKey: 'staticPages.vaccination.ageGroups.newborn',
    imageFile: 'newborn',
  },
  {
    value: 1,
    labelKey: 'staticPages.vaccination.ageGroups.sixWeeks',
    imageFile: '6weeks',
  },
  {
    value: 2,
    labelKey: 'staticPages.vaccination.ageGroups.tenWeeks',
    imageFile: '10weeks',
  },
  {
    value: 3,
    labelKey: 'staticPages.vaccination.ageGroups.fourteenWeeks',
    imageFile: '14weeks',
  },
  {
    value: 4,
    labelKey: 'staticPages.vaccination.ageGroups.sixAndSevenMonths',
    imageFile: '6&7months',
  },
  {
    value: 5,
    labelKey: 'staticPages.vaccination.ageGroups.nineMonths',
    imageFile: '9months',
  },
  {
    value: 6,
    labelKey: 'staticPages.vaccination.ageGroups.eighteenMonths',
    imageFile: '18months',
  },
  {
    value: 7,
    labelKey: 'staticPages.vaccination.ageGroups.twentyFourMonths',
    imageFile: '24months',
  },
  {
    value: 8,
    labelKey: 'staticPages.vaccination.ageGroups.girlsAtTenYears',
    imageFile: 'girls10years',
  },
  {
    value: 9,
    labelKey: 'staticPages.vaccination.ageGroups.pregnantWomenAndInjuries',
    imageFile: 'pregnant',
  },
];

function Vaccination() {
  const { t } = useTranslation();
  const [selectedAgeGroup, setSelectedAgeGroup] = useState();
  const translatedAgeGroups = useMemo(
    () =>
      ageGroups.map((group) => ({
        value: group.value,
        label: t(group.labelKey),
      })),
    [t]
  );

  const getImagePath = () => {
    if (selectedAgeGroup === undefined) {
      return require('../../assets/milestoneChecker/vaccination/default.png');
    }

    const selectedGroup = ageGroups.find((group) => group.value === selectedAgeGroup);
    const languageCode = i18n.language === 'Swahili' ? 'sw' : 'en';
    return require(`../../assets/milestoneChecker/vaccination/${languageCode}/${selectedGroup.imageFile}.png`);
  };

  const getImageAlt = () => {
    if (selectedAgeGroup === undefined) {
      return t('staticPages.vaccination.defaultDiagramAlt');
    }
    const selectedGroup = ageGroups.find((group) => group.value === selectedAgeGroup);
    return t(selectedGroup.labelKey);
  };

  return (
    <div className={styles.vaccinationStaticPage}>
      <div className={styles.vaccinationStaticPage_paragraph}>
        <KitoBuddy mascotWidth={120} speech marginBottom="var(--spacing-m)" gif>
          <h4>{t('staticPages.vaccination.title')}</h4>
          <p>{t('staticPages.vaccination.subtitle')}</p>
        </KitoBuddy>
        <KitoSelect
          width="75%"
          value={selectedAgeGroup}
          options={translatedAgeGroups}
          onChange={setSelectedAgeGroup}
          placeholder={t('staticPages.vaccination.selectPlaceholder')}
        />
      </div>
      <div className={styles.vaccinationStaticPage_illustration}>
        <img
          src={getImagePath()}
          alt={getImageAlt()}
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
    </div>
  );
}

export default Vaccination;
